import { Text, Title } from "@mantine/core";
import { ContextModalProps } from "@mantine/modals";
import { SealCheckIcon, SealWarningIcon } from "@phosphor-icons/react";
import { useEffect } from "react";

import { cn } from "@/utils/cn";

type ConnectionStatusProps = {
  isOnline: boolean;
};

export function ConnectionStatus({ id, context, innerProps }: ContextModalProps<ConnectionStatusProps>) {
  const { isOnline } = innerProps;

  useEffect(() => {
    const interval = setInterval(() => {
      context.closeModal(id);
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className={cn("grid place-content-center")}>
      <Title ta="center" fw="normal" order={1}>
        Status da conexão
      </Title>

      <Text c={isOnline ? "green" : "red"} size="4xl" className="flex items-center justify-center gap-1 text-4xl font-semibold">
        {isOnline && (
          <>
            Online
            <SealCheckIcon weight="bold" />
          </>
        )}

        {!isOnline && (
          <>
            Offline
            <SealWarningIcon weight="bold" />
          </>
        )}
      </Text>
    </div>
  );
}

export const ExpeditionsConnection = {
  status: ConnectionStatus
};
